export default "__VITE_ASSET__tdhrcIgx__"